export default __webpack_public_path__ + "static/media/witness.ce31c5e6.jpg";